import memoize from 'lodash/memoize';

import {getTrackLineRequests, type GetTrackLineRequestsOptions} from './getTrackLineRequests';

const inner = memoize(
    async (lineRequests: TrackLineRequest[]): Promise<GeoJSON.MultiLineString> => {
        const lines = await Promise.all(lineRequests.map((request) => request.geometry));
        return {
            type: 'MultiLineString',
            coordinates: lines.map((line) => line.coordinates),
        };
    },
    JSON.stringify
);

export default function fetchTrackMultiline(options: GetTrackLineRequestsOptions) {
    return inner(getTrackLineRequests(options));
}
